import { render, staticRenderFns } from "./ComPdf.vue?vue&type=template&id=3b785eea&"
import script from "./ComPdf.vue?vue&type=script&lang=js&"
export * from "./ComPdf.vue?vue&type=script&lang=js&"
import style0 from "./ComPdf.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports